import React from 'react';

const Required: React.FC = () => (
  <span className="has-text-danger">*</span>
);

export default Required;
